export default "__VITE_ASSET__CmQ_JYLe__"